import React, { createContext, useContext, useState, useEffect } from 'react';
import { useColorMode } from '@chakra-ui/react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const { colorMode, toggleColorMode } = useColorMode();
  const [themeMode, setThemeMode] = useState(localStorage.getItem('theme_mode') || 'dark');

  useEffect(() => {
    document.documentElement.classList.toggle('dark', colorMode === 'dark');
    localStorage.setItem('theme_mode', colorMode);
  }, [colorMode]);

  const handleToggle = () => {
    toggleColorMode();
    setThemeMode(colorMode === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ isDark: colorMode === 'dark', colorMode, toggleTheme: handleToggle }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
